<template>
    <div class="coverflow">

        <carousel-3d ref="carousel" :height="300" @after-slide-change="onAfterSlideChange">
            <slide v-for="(image, $index) in images" :index="$index">
                <img :src="image.src" :key="$index"  @click="currentSlide = $index">
                <span class="filename">{{image.name}}</span>
            </slide>
        </carousel-3d>
        <div class="row">
            <div class="metadata col-xs-6" v-if="images && images.length > 0">
                <div class="form-group">
                    <label>Caption (one word) *</label>
                    <input class="form-control" placeholder="Example: wide, closeup, boots, head, gun" v-model="images[currentSlide].descriptor" type="text">
                </div>
                <div class="form-group">
                    <label>Discipline(s) *</label>
                    <select @change="addDiscipline($event, currentSlide)" class="form-control" v-model="discipline">
                        <option default disabled selected>Select all that apply</option>
                        <option v-for="discipline in disciplines" :disabled="images[currentSlide].disciplines.includes(discipline)">{{discipline}}</option>
                    </select>
                    <ul class="disciplines">
                        <li v-for="(discipline, $disciplineIndex) in images[currentSlide].disciplines">
                            {{discipline}}
                            <div class="buttons">
                                <button @click.prevent="removeDiscipline($disciplineIndex)" class="remove-discipline">x</button>
                                <button @click.prevent="applyDisciplineToAll(discipline)" class="btn btn-xs apply-to-all">Apply to All</button>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { Carousel3d, Slide } from 'vue-carousel-3d';
import { clone } from 'lodash';
import Galleries from '../../services/galleries';
import toastr from 'toastr';

export default {
    props: ['images'],
    data() {
        return {
            disciplines: null,
            currentSlide: 0
        }
    },
    components: {
        Carousel3d,
        Slide
    },
    mounted() {

        Galleries.getCloudinaryField('13_discipline').then((response) => {
            this.disciplines = response.values.map(d => d.value);
        });
      
    },

    watch: {
        images: function(i) {
            this.$nextTick(() => {
                this.$refs.carousel.total = this.images.length;
                this.$refs.carousel.goNext();
            })
        }
    },

    methods: {
        onAfterSlideChange(index) {
            this.currentSlide = index;
            this.discipline = null;
        },
        setCurrentSlide(index) {
            this.currentSlide = index;
            this.$refs.coverflow.goTo(this.currentSlide)
        },
        addDiscipline(e, index) {
            this.images[index].disciplines.push(e.target.value);
            this.discipline = null;

        },
        applyDisciplineToAll(discipline) {
            for (let asset of this.images) {
                if (!asset.disciplines.includes(discipline)) {
                    asset.disciplines.push(discipline);
                }
            }
            toastr.success('Applied to all');
        },
        removeDiscipline(mediaIndex, disciplineIndex) {
            this.images[this.currentSlide].disciplines.splice(disciplineIndex, 1);
        },

        calculateStyle(index) {
            let transforms;

            if (index < this.currentSlide) {
                transforms = "translateX(" + ((index + 1) * -10) + "px) rotateY(-20deg)";
            } else if (index > this.currentSlide) {
                transforms = "translateX(" + ((index + 1) * 10) + "px) rotateY(20deg)";
            } else if (index === this.currentSlide) {
                transforms = "scale(1.12)";

            }
            return `transform: ${transforms}`;

        }
    },
    computed: {

    }
}

</script>
<style lang="scss" scoped>
.coverflow {
    margin-bottom: 1rem;
}

.row>div {
    margin: 0 auto;
    float: none;
}

ul.disciplines {
    margin-top: 1rem;
    color: #3cf;

    li {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: .5rem;
    }

    .apply-to-all {
        background: #3cf;
        color: #222;
    }

    .remove-discipline {
        background: transparent;
        position: relative;
        top: 2px;
        color: #3cf;
        border: none;
        boxs-shadow: none;
    }
}

.jp-slide {
    padding: 1rem;
    cursor: pointer;

    &>div {
        transform-style: preserve-3d;
        transition: all .25s;
        padding-bottom: 2rem;
    }

    img {
        width: 260px !important;
        height: 260px !important;
        object-fit: cover;
    }
}

</style>
<style lang="scss">
.carousel-3d-slide {
    border:none!important;
    background:transparent!important;
    text-align:center!important;
    .filename {
        margin-top:5px;
        display:inline-block;
    }
    img {
        width: 100%;
        height: 272px;
        cursor: pointer;
        object-fit: cover;
    }
}

</style>



// WEBPACK FOOTER //
// Coverflow.vue?1bbfa8c9